import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { TimeZoneLocalizationService } from 'app/modules/main/services/time-zone-localization.service';
import { PublisherTimeZoneState } from 'app/modules/main/store/publisher-time-zone/publisher-time-zone.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PublisherTimeZoneSelectors {

  static readonly FEATURE = 'PublisherTimeZone';

  private readonly feature = createFeatureSelector<PublisherTimeZoneState>(
    PublisherTimeZoneSelectors.FEATURE
  );

  private readonly timeZone = createSelector(
    this.feature,
    (state: PublisherTimeZoneState) => state.timeZone
  );

  private readonly timeZoneName = createSelector(
    this.feature,
    (state: PublisherTimeZoneState) => state.timeZoneName
  );

  private readonly timeZoneLoaded = createSelector(
    this.feature,
    (state: PublisherTimeZoneState) => state.timeZoneLoaded
  );

  constructor(
    private readonly store: Store<PublisherTimeZoneState>,
    private readonly timeZoneLocalizationService: TimeZoneLocalizationService,
  ) {
  }

  public hasTimeZoneLoaded(): Observable<boolean> {
    return this.store.select(this.timeZoneLoaded);
  }

  public onTimeZoneLoaded(): Observable<boolean> {

    return this.hasTimeZoneLoaded()
      .pipe(filter(x => !!x));
  }

  public getTimeZone(): Observable<string> {

    return this.onTimeZoneLoaded()
      .pipe(switchMap(() => this.store.select(this.timeZone)));
  }

  public getTimeZoneLabel(): Observable<string> {

    return this.onTimeZoneLoaded()
      .pipe(
        switchMap(() => this.store.select(this.timeZoneName)),
        map(timeZoneName => this.timeZoneLocalizationService.localizeName(timeZoneName)),
      );
  }

}
